<template>
  <div>
    <jala-farm-select-ajax
        v-if="!initialValue.farm_id"
        v-show="!value"
        :key="`${_uid}-jala-ponds-farms`"
        name="farm_id"
        v-model.number="farm_id"
        :initial-value="initialValue"
    ></jala-farm-select-ajax>
    <multiselect-ajax
        v-show="farm_id || value"
        :class="{ 'mt-3': !(value || initialValue.farm_id) }"
        :key="`${_uid}-jala-ponds-${farm_id}`"
        name="pond_id"
        :placeholder="$t('Select {something}', { something: $t('jala_ponds.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel || customLabelDefault"
        :required="required"
        :disabled="disabled"
        :url="`/jala/ponds`"
        :params="{ farm_id__in: farm_id, with: 'farm', ...params }"
    >
      <template v-slot:beforeList>
        <b-button variant="link" v-b-modal="`${_uid}-jala-pond-create-modal`">+
          {{ $t('Add new {something}', {something: $t('jala_ponds.singular')}) }}
        </b-button>
        <jala-pond-create-modal
            :key="`${_uid}-jala-pond-create-modal-${value}`"
            :id="`${_uid}-jala-pond-create-modal`"
            size="lg"
            @created="onInput($event.id)"
            :initial-value="{ farm_id }"
        ></jala-pond-create-modal>
      </template>
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "./vue-multiselect-ajax";
import JalaPondCreateModal from '../modals/jala-pond-create';
import JalaFarmSelectAjax from "@/components/inputs/jala-farm-select-ajax";

export default {
  name: "jala-pond-select-ajax",
  components: {
    JalaFarmSelectAjax,
    MultiselectAjax,
    JalaPondCreateModal,
  },
  props: {
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      farm_id: this.initialValue.farm_id || null
    }
  },
  computed: {
    customLabelDefault() {
      if (this.value)
        return (v) => `${v.farm.name} - ${v.name}`;
      else return undefined
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
